<template>
  <Reservation />
</template>

<script>
import Reservation from '../components/Reservation';

export default {
  name: 'Home',
  components: {
    Reservation,
  },
};
</script>
